import { getATLContextUrl } from '@atlaskit/atlassian-context';

export const redirectToHome = ({
	email,
	orgId,
	cloudId,
}: {
	email: string;
	orgId?: string;
	cloudId: string;
}): void => {
	const urlWithSynchronisation = getSessionSynchronisationUrl(
		buildAtlassianHomeUrl({ orgId, cloudId }),
		email,
	);

	window.location.assign(urlWithSynchronisation);
};

export function buildAtlassianHomeUrl({ orgId, cloudId }: { orgId?: string; cloudId: string }) {
	const homeRedirectUrl = getATLContextUrl('home').replace('http:', 'https:');
	const searchParams = new URLSearchParams(window.location.search);
	searchParams.set('cloudId', cloudId);
	return `${homeRedirectUrl}${
		orgId ? `/o/${orgId}` : ''
	}${getRedirectPath()}?${searchParams.toString()}`;
}

function getRedirectPath() {
	const fullPath = window.location.pathname;
	// Remove everything before /people
	return fullPath.substring(fullPath.indexOf('/people'));
}

function getLogInUrl(redirectUrl?: string) {
	const href = redirectUrl || window.location.href;
	return `${getATLContextUrl('id').replace(
		'http:',
		'https:',
	)}/login?continue=${encodeURIComponent(href)}&application=people`;
}

// https://developer.atlassian.com/platform/identity/learning/sso/integrate-with-account-switcher/#synchronize-accounts
function getSessionSynchronisationUrl(url: string, userEmail = '') {
	return getLogInUrl(url) + `&prompt=none&login_hint=${userEmail}`;
}
